import React, { useState } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { Brain, Settings, Sparkles } from 'lucide-react';

const iconMap = {
  gpt4: Brain,
  intent: Sparkles,
  rag: Brain,
  sentiment: Brain
};

const AINode = ({ data, id, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  const Icon = iconMap[data.subtype] || Brain;

  return (
    <div
      style={{
        padding: '16px',
        borderRadius: '12px',
        border: `2px solid ${selected ? '#7c3aed' : '#a855f7'}`,
        background: 'rgba(168, 85, 247, 0.1)',
        minWidth: '220px',
        boxShadow: selected ? '0 0 20px rgba(168, 85, 247, 0.4)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s'
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: '#a855f7',
          width: 12,
          height: 12,
          border: '2px solid white'
        }}
      />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Icon size={20} color="#a855f7" />
          <div>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#1f2937' }}>
              {data.label || 'AI Node'}
            </div>
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
              {data.config?.model || 'GPT-4'} · {data.config?.temperature || 0.7}
            </div>
          </div>
        </div>

        <button
          onClick={() => setShowConfig(!showConfig)}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 4,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Settings size={16} color="#6b7280" />
        </button>
      </div>

      {showConfig && (
        <div style={{
          marginTop: 12,
          padding: 12,
          background: 'white',
          borderRadius: 8,
          fontSize: 12,
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>
              System Prompt:
            </label>
            <textarea
              value={data.config?.systemPrompt || ''}
              readOnly
              style={{
                width: '100%',
                minHeight: 60,
                padding: 8,
                borderRadius: 4,
                border: '1px solid #d1d5db',
                fontSize: 11,
                fontFamily: 'monospace'
              }}
            />
          </div>
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: '#a855f7',
          width: 12,
          height: 12,
          border: '2px solid white'
        }}
      />
    </div>
  );
};

export default AINode;
